export enum WeeklyDataUpdateByType{
    Clinician=1, 
    Teacher=2,
    Parent=3,
}